/* @flow */

export * from './ie';



// WEBPACK FOOTER //
// ./src/compat/index.js